<script>
export default {
    props: ['link'],
    methods: {
        addToCalendar() {
            if (confirm(this.__('Please note: check whether the correct time has been placed in your agenda. It sometimes happens that settings in Outlook cause a 1 hour time difference.'))) {
                window.location = this.link;
            }
        }
    }
}
</script>
<template>
    <a class="my-3 d-flex align-items-center small" :href="link" @click.prevent="addToCalendar">
        <i class="fa fa-calendar-plus-o me-2" style="font-size: 30px;"></i>
        {{ __('Add to calendar') }}
    </a>
</template>
